import React, { FC, useMemo } from 'react'
import { IonToggle } from '@ionic/react'
import { observer } from 'mobx-react'
import { cartMobx, orderMobx, menuMobx } from 'restaurant'
import { multiPersonMobx } from '@mobxStore'
import { format, deepClone } from '@dt/fe-utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { Avatar } from '@cps'
import ProductItem from './ProductItem'
import MultiProductItem from './MultiProductItem'
import './index.scss'
import OrderYellowTitleBar from '../OrderYellowTitleBar'

const CheckoutProduct: FC = () => {
  const menuProductsMap = useMemo(() => {
    return keyBy(menuMobx.products, 'no')
  }, [menuMobx.products])

  const getNewItem = (item) => {
    const newItem = deepClone(item)
    if (menuMobx.products?.length) {
      newItem.pic = menuProductsMap[item.productNo]?.pic
    }
    return newItem
  }

  // 换购
  const exChangeItems = (
    swapBuyProducts: IViewCartItem[],
    status: 'WAIT_PLACE' | 'WAIT_CONFRIM' | 'ORDERED' | ''
  ) => {
    if (!swapBuyProducts?.length) {
      return null
    }
    return swapBuyProducts
      .filter((cartItem) => !!cartItem && cartItem.name)
      .map((item) => <ProductItem key={item.pk} status={status} item={item} />)
  }

  // 满送
  const fnChangeItems = (
    fullItemNFreeProducts: IViewCartItem[],
    status: 'WAIT_PLACE' | 'WAIT_CONFRIM' | 'ORDERED' | ''
  ) => {
    if (!fullItemNFreeProducts?.length) {
      return null
    }
    return fullItemNFreeProducts
      .filter((cartItem) => !!cartItem && cartItem.name)
      .map((item) => <ProductItem key={item.pk} status={status} item={item} />)
  }

  const formatProductItemArr = (arr) => {
    const _obj = {}
    const newArr = []
    arr.sort((a, b) => b.addTimeStamp - a.addTimeStamp).map(item => {
      const time = item.addTime.split(' ').join('')
      if (!_obj[time]) {
        _obj[time] = []
      }

      _obj[time].push(item)
    })

    Object.values(_obj).map((value: any[]) => {
      if (!value.length) return
      if (value.length === 1) {
        newArr.push(value[0])
      } else {
        newArr.push(value)
      }
    })

    return newArr
  }

  const newProductItemArr = (item, isMulti: boolean) => {
    return (
      <div key={item.detailId}>
        {
          isMulti ? (
            <>
              <MultiProductItem
                status={cartMobx.info.payMode ? 'ORDERED' : ''}
                item={getNewItem(item)}
              />
              <div className='add-user'>
                {item.addUsers?.map((user) => {
                  return <Avatar key={user} userKey={user} />
                })}
              </div>
            </>
          ) : (
            <ProductItem
              status={cartMobx.info.payMode ? 'ORDERED' : ''}
              key={item.detailId}
              item={getNewItem(item)}
            />
          )
        }
      </div>
    )
  }

  return (
    <div className='checkout-product'>
      <div className='checkout-product-list'>
        {multiPersonMobx.isMultiPerson ? (
          <>
            {!cartMobx.orderMerge ? (
              <>
                {
                  formatProductItemArr(cartMobx.viewCombinedOrderItems).map((orderItem, index: number) => {
                    const isArray = Array.isArray(orderItem)
                    // 展示黄色标题
                    const isShowYellowTitle = !cartMobx.cartItems.length && cartMobx.info.payMode === 1 && index === 0
                    const item = isArray ? orderItem[0] : orderItem
                    return (
                      <div className='checkout-product-newItem' key={item.detailId}>
                        {isShowYellowTitle ? (
                          <OrderYellowTitleBar orderItem={item} eatType={orderMobx.viewOrder.eatType} />
                        ) : (
                          <p className='time'>{format.toDateTime(item.addTime)}{i18n.t('cart.placeOrder')}</p>
                        )}
                        {isArray ? orderItem.map(item => newProductItemArr(item, true)) : newProductItemArr(orderItem, true)}
                      </div>
                    )
                  })
                }
                {
                  orderMobx.viewOrder.isWait && cartMobx.viewCombinedCartItems.map((cartItem) => {
                    const status = orderMobx.viewOrder.isWait ? 'WAIT_CONFRIM' : 'WAIT_PLACE'
                    return (
                      <div key={cartItem.pks.join('')}>
                        <MultiProductItem status={status} item={getNewItem(cartItem)} />
                        {exChangeItems(cartItem.swapBuyProducts, status)}
                        {fnChangeItems(cartItem.fullItemNFreeProducts, status)}
                        <div className='add-user'>
                          {cartItem.addUsers?.map((user) => {
                            return <Avatar key={user} userKey={user} />
                          })}
                        </div>
                      </div>
                    )
                  })
                }
              </>
            ) : (
              <>
                {Object.keys(cartMobx.viewUserOrderItems).map((user) => {
                  return (
                    <section key={user}>
                      <div className='user-info'>
                        <Avatar key={user} userKey={user} />
                        <span>
                          {user === 'waiter'
                            ? i18n.t('common.waiter')
                            : multiPersonMobx.multiPersonMap[user]?.nickName}
                        </span>
                      </div>
                      {cartMobx.viewUserOrderItems[user].map((orderItem) => {
                        return (
                          <>
                            <div key={orderItem.detailId}>
                              <ProductItem
                                status={cartMobx.info.payMode ? 'ORDERED' : ''}
                                key={orderItem.detailId}
                                item={getNewItem(orderItem)}
                              />
                            </div>
                          </>
                        )
                      })}
                    </section>
                  )
                })}
              </>
            )}
          </>
        ) : (
          <>
            {
              /** 单人点餐订单 */
              formatProductItemArr(cartMobx.viewOrderItems).map((orderItem, index) => {
                const isArray = Array.isArray(orderItem)
                // 展示黄色标题
                const isShowYellowTitle = !cartMobx.cartItems.length && cartMobx.info.payMode === 1 && index === 0
                const item = isArray ? orderItem[0] : orderItem
                return (
                  <div className='checkout-product-newItem' key={item.detailId}>
                    {isShowYellowTitle ? (
                      <OrderYellowTitleBar orderItem={item} eatType={orderMobx.viewOrder.eatType} />
                    ) : (
                      <p className='time'>{format.toDateTime(item.addTime)}{i18n.t('cart.placeOrder')}</p>
                    )}
                    {isArray ? orderItem.map(item => newProductItemArr(item, false)) : newProductItemArr(orderItem, false)}
                  </div>
                )
              })
            }
            {/* 单人点餐购物车 */}
            {
              orderMobx.viewOrder.isWait && cartMobx.viewCartItems
                .filter((item) => item.cnt && !item.disabled)
                .map((cartItem) => {
                  const status = cartMobx.info.payMode ? 'WAIT_CONFRIM' : null
                  return (
                    <div key={cartItem.pk}>
                      <ProductItem status={status} item={getNewItem(cartItem)} />
                      {exChangeItems(cartItem.swapBuyProducts, status)}
                      {fnChangeItems(cartItem.fullItemNFreeProducts, status)}
                    </div>
                  )
                })
            }
          </>
        )}
      </div>
      {multiPersonMobx.isMultiPerson && !cartMobx.needPack && (
        <section className='cart-product-merge'>
          <div>
            <span>{i18n.t('newCart.orderMerge')}</span>
          </div>
          <IonToggle
            disabled={cartMobx.needPack}
            checked={cartMobx.orderMerge}
            onIonChange={(e) => cartMobx.setOrderMerge(e.detail.checked)}
          />
        </section>
      )}
    </div>
  )
}

export default observer(CheckoutProduct)
